import { Network } from '@puzzlehq/types';
import { trpcReact } from '../data/trpc';
import { useAccount } from '@puzzlehq/sdk';
import { useEffect, useState } from 'react';
import { useAleoBalance } from './useAleoBalance';

type UseFeeProps = {
  programId?: string;
  functionId?: string;
  network?: Network;
};

export const useFeeQuery = ({
  programId,
  functionId,
  network: _network,
}: UseFeeProps) => {
  const network: Network = _network ?? import.meta.env.VITE_NETWORK!;
  const { account } = useAccount();

  const enabled = !!programId && !!functionId;

  return trpcReact.getFeeWithCoverage.useQuery(
    {
      programId: programId!,
      functionId: functionId!,
      network: network ?? Network.AleoMainnet,
      address: account?.address,
    },
    {
      enabled: enabled,
      refetchInterval: 30000,
    }
  );
};

export const useFeeValid = ({
  programId,
  functionId,
  network: _network,
}: UseFeeProps) => {
  const [feeValid, setFeeValid] = useState<boolean | undefined>();
  const feeQuery = useFeeQuery({
    programId,
    functionId,
    network: _network,
  });
  const { creditsBalance } = useAleoBalance();

  useEffect(() => {
    if (!!feeQuery.data) {
      if (feeQuery.data?.covered) {
        setFeeValid(true);
      }
      if (!!creditsBalance && !!feeQuery.data.fee) {
        const fee = feeQuery.data.fee.fee.total;
        const hasSufficientPublicBalance = creditsBalance.values.public >= fee;
        const hasSufficientPrivateBalance =
          creditsBalance.values.private >= fee;
        if (hasSufficientPublicBalance || hasSufficientPrivateBalance) {
          setFeeValid(true);
        }
      }
    }
  }, [creditsBalance, feeQuery.data]);

  return feeValid;
};
